module.exports = __webpack_public_path__ + "static/media/googlePin7.c28ee7c1.svg";